// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__26V9a","icon":"StyledButton_icon__1hwvG","text":"StyledButton_text__3aNNh"};